import dialogStore from '../stores/dialog';

export function appAlert(message, options = {}) {
    return dialogStore.request('alert', message, '', options);
}

export function appConfirm(message, options = {}) {
    return dialogStore.request('confirm', message, '', options);
}

export function appPrompt(message, defaultValue = '', options = {}) {
    return dialogStore.request('prompt', message, defaultValue, options);
}
